module.exports = __webpack_public_path__ + "img/bg.02861732.png";